"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PartnerContextProvider = exports.PartnerContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _emailUtils = require("../../../utils/emailUtils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultValue = {
  isWl: false,
  name: 'level.travel',
  logo: (0, _emailUtils.getImage)('leveltravel_logo_black.png'),
  link: 'https://level.travel/'
};

// если Provider не указан, возвращаем стандартные значение
var PartnerContext = exports.PartnerContext = /*#__PURE__*/_react["default"].createContext(defaultValue);
var PartnerContextProvider = exports.PartnerContextProvider = function PartnerContextProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/_react["default"].createElement(PartnerContext.Provider, {
    value: _objectSpread(_objectSpread({}, defaultValue), value)
  }, children);
};
PartnerContextProvider.defaultProps = {
  value: defaultValue
};
PartnerContextProvider.propTypes = {
  children: _propTypes["default"].node.isRequired,
  value: _propTypes["default"].shape({
    isWl: _propTypes["default"].bool,
    name: _propTypes["default"].string,
    logo: _propTypes["default"].string,
    link: _propTypes["default"].string
  })
};